 import React from 'react';
import PropTypes from 'prop-types';
import ModuleBlock from "../ModuleBlock";
import withTranslation from "../../../../../hoc/withTranslation";
import ModuleService from "../../../../../services/module";
 import {List, ListItem} from 'material-ui/List';
 import styles from './FirebaseModuleBlock.css';
 import Error from 'material-ui/svg-icons/alert/error';
 import { white } from 'material-ui/styles/colors';

class FirebaseModuleBlock extends React.Component {
    static propTypes = {
        app: PropTypes.object.isRequired
    };

    render() {

        let content = null;

        if (this.props.app.configurations.firebase_configuration_file === null) {
            content = <List>
                <ListItem
                    style={styles.list}
                    disabled={true}
                    primaryText={this.props.t('module.firebase.configuration_ko')}
                    leftIcon={<Error color={white}/>}/>
            </List>;
        }

        return (
            <ModuleBlock app={this.props.app} module={ModuleService.getModule(ModuleService.FIREBASE)} content={content}/>
        );
    }
}

export default withTranslation(FirebaseModuleBlock);



// WEBPACK FOOTER //
// src/components/application/ApplicationFull/ModuleBlock/FirebaseModuleBlock/FirebaseModuleBlock.js